<template>
  <div>
    <div class="windows">

      <a-table :data-source="goods.list" style="margin-top: 20px;" rowKey="id" :pagination="pagination" @change="onPaginationChange">
        <a-table-column key="goods" title="商品名称" data-index="time_str">
          <template slot-scope="text, record">
            <div class="goods"  @click="handleDetail(record)">
              <img :src="record.goods_img" class="goods-img"/>
              <div style="display: flex;flex-direction: column;justify-content: space-between;">
                <div class="goods-title">{{ record.goods_title }}</div>
                <div style="display: flex;">
                  <div class="goods-price">券后价<span style="font-size: 16px;">{{ record.cost_price }}</span></div>
                  <div class="goods-oprice">原价<span style="font-size: 16px;">{{ record.price }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </a-table-column>
        <a-table-column key="commission" title="佣金" data-index="commission"/>
        <!--        <a-table-column key="action" title="操作">-->
        <!--          <template slot-scope="text, record">-->
        <!--        <span style="font-size: 20px;">-->
        <!--          <a-tooltip placement="top">-->
        <!--            <template slot="title">-->
        <!--              <span>删除收藏</span>-->
        <!--            </template>-->
        <!--            <a style="color: #ff4242;margin-left: 12px;" @click="() => onDelete(record)"><a-icon type="delete"/></a>-->
        <!--          </a-tooltip>-->
        <!--        </span>-->
        <!--          </template>-->
        <!--        </a-table-column>-->
      </a-table>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
const {mapGetters} = createNamespacedHelpers('user')
import { fetchWindow } from '@/api/goods-list'
export default {
  name: "mine-window",
  props: {
    pvd: String
  },
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      goods: [],
    }
  },
  computed: {
    ...mapGetters({userInfo: 'getUserInfo'}),
  },
  mounted() {
    this.fetchGoods()
  },
  methods: {
    onSearch() {

    },
    handleDetail(item) {
      console.log(item)
      const url = this.$router.resolve({
        path: '/goods-detail',
        query: {
          id: item.gid,
          pvd: item.type,
        }
      })
      window.open( url.href, '_blank')
    },
    fetchGoods() {
      fetchWindow({
        p: `${this.pagination.current}`,
        size: `${this.pagination.pageSize}`
      }, this.pvd).then(res => {
        console.log(res)
        this.goods = res
      })
    },
    onPaginationChange(pagination) {
      console.log(pagination, this.pagination)
      this.pagination = pagination
      this.fetchGoods()
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217,217,217,0.19);
  border-radius: 13px;
  padding: 24px;
}

.profile {
  height: 125px;
  display: flex;
  align-items: center;
  position: relative;
  .avatar {
    flex-shrink: 0;
    width: 76px;
    height: 76px;
    margin-right: 8px;
    border-radius: 50px;
  }
  .profile-cnt {
    flex-grow: 1;
    overflow: hidden;
    .nickname {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
    .phone {
      margin-top: 4px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
  }
  @media screen and (min-width: 576px) and (max-width: 760px) {
    .profile-cnt {
      display: none;
    }
  }

  .switch {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    font-size: 12px;
    color: #333333;
  }
}

.datas {
  height: 125px;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
    .more {
      font-size: 14px;
      color: #B0B0B0;
      line-height: 20px;
    }
  }

  .body {
    display: flex;
    flex-grow: 1;

    .item {
      display: flex;
      flex: 1;
      flex-direction: column;
      margin-right: 8px;
      .value {
        font-size: 26px;
        font-weight: 500;
        color: #333333;
        line-height: 37px;
      }
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #A6A6A6;
        line-height: 20px;
      }
    }
  }
}

.windows {
  margin-top: 12px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;

    .tag {
      width: 3px;
      height: 15px;
      background: #FA6400;
      margin-right: 4px;
    }

  }

  .goods {
    display: flex;
    cursor: pointer;

    .goods-img {
      width: 72px;
      height: 72px;
      border-radius: 8px;
      margin-right: 8px;
    }

    .goods-title {
      font-size: 14px;
      color: #000000;
      line-height: 30px;
    }

    .goods-price {
      font-size: 11px;
      font-weight: 500;
      color: #FF4242;
      line-height: 16px;
    }

    .goods-oprice {
      font-size: 11px;
      font-weight: 500;
      color: #C0C0C0;
      line-height: 16px;
      margin-left: 8px;
      text-decoration: line-through;
    }
  }
}
</style>
